export const getters = {
    getVersion: (state) => {
        return state.version;
    },
    getGraphQLApiUrl: (state) => {
        return state.graphQLApiUrl;
    },
};
